import './App.css';

import AppCarousel from './features/home/components/AppCarousel';
import Rooter from './Rooter';
import TopToolbar from './components/TopToolbar';
import { useSiteI18n } from './i18n/siteI18n';

function Home() {
  const { t } = useSiteI18n();

  return (
    <div className="App">
      <div className="App-content">
        <TopToolbar />
        <img src="/img/mnf-white.png" className="App-logo" alt="logo" />
        <AppCarousel />
        <section className="App-intro" aria-label="About My Nature Friends">
          <h2 className="App-intro-title">{t('homeIntroTitle')}</h2>
          <p className="App-intro-text">{t('homeIntro')}</p>
        </section>
      </div>
      <Rooter />
    </div>
  );
}

export default Home;
